export const CONFIG_ADD_NO_OF_DAYS = "config_add_no_of_days";
export const CONFIG_EXPIRE = "config_expire";
export const FETCH_SCHEDULAR_SUCCESS = "fetch_schedular_success";
export const FETCH_SCHEDULAR_DAY = "fetch_schedular_day";
export const SCHEDULAR_DAY_EDIT = "schedular_day_edit";
export const FETCH_SCHEDULAR_EXPIRE_TIME_SUCCESS = "fetch_schedular_expire_time_success";
export const FETCH_SCHEDULAR_EXPIRE_TIME = "fetch_schedular_expire_time";
export const SCHEDULAR_EXPIRE_TIME_EDIT = "schedular_expire_time_edit";
export const GET_SESSIONS = "get_sessions";
export const GET_SESSIONS_SUCCESS = "get_sessions_success";
export const CLEAR_SESSIONS = "clear_sessions";